// extracted by mini-css-extract-plugin
export var carrierTab = "_4e-0";
export var carrierTabActive = "_4e-1 _4e-0";
export var carrierTabInactive = "_4e-2 _4e-0";
export var carrierTabLabel = "_4e-3";
export var carrierTabLabelActive = "_4e-4 _4e-3";
export var carrierTabLabelInactive = "_4e-5 _4e-3";
export var carrierTabPercentage = "_4e-6";
export var carrierTabPercentageActive = "_4e-7 _4e-6";
export var carrierTabPercentageInactive = "_4e-8 _4e-6";
export var carrierTabWinnable = "_4e-9";
export var carrierTabWinnableActive = "_4e-a _4e-9";
export var carrierTabWinnableInactive = "_4e-b _4e-9";
export var comparisonContainer = "_4e-d";
export var missingRateButton = "_4e-n";
export var missingRateButtonActive = "_4e-o _4e-n";
export var missingRateButtonInactive = "_4e-p _4e-n";
export var missingRateButtonLabel = "_4e-q";
export var missingRateButtonLabelActive = "_4e-r _4e-q";
export var missingRateButtonLabelInactive = "_4e-s _4e-q";
export var sidebar = "_4e-c";
export var strategyButton = "_4e-e";
export var strategyButtonActive = "_4e-f _4e-e";
export var strategyButtonDescription = "_4e-k";
export var strategyButtonDescriptionActive = "_4e-l _4e-k";
export var strategyButtonDescriptionInactive = "_4e-m _4e-k";
export var strategyButtonInactive = "_4e-g _4e-e";
export var strategyButtonLabel = "_4e-h";
export var strategyButtonLabelActive = "_4e-i _4e-h";
export var strategyButtonLabelInactive = "_4e-j _4e-h";
export var unitToggleButton = "_4e-t";
export var unitToggleButtonActive = "_4e-u _4e-t";
export var unitToggleButtonInactive = "_4e-v _4e-t";
export var unitToggleButtonLabel = "_4e-w";
export var unitToggleButtonLabelActive = "_4e-x _4e-w";
export var unitToggleButtonLabelInactive = "_4e-y _4e-w";